module.exports = __webpack_public_path__ + "img/ciclebg2.3921d612.svg";